import { defineMessages } from "react-intl";

export const homePageMessages = defineMessages({
  salesCardTitle: {
    defaultMessage: "Sales",
    id: "c8nvms",
  },
  ordersCardTitle: {
    defaultMessage: "Orders",
    id: "X7jl6w",
  },
});
